<template>
  <div style="position: absolute; width: 100%; height:100%; overflow: hidden;" v-loading="loading" element-loading-text="页面加载中..." element-loading-background="rgba(0, 0, 0, 0.8)">
    <!-- 滑动容器 -->
    <div class="carousel-track" :style="{ transform: `translateX(-${activeIndex * 100}%)` }">
      <div v-for="(item, i) in ruleForm.urls" :key="i" class="carousel-item">
        <div style="display: flex; flex-direction: column;width: 100%; height:100%;">
          <iframe
            :style="{ pointerEvents: allowIframeClick ? 'auto' : 'none' }"
            style="width: 100%; height: 100%; margin: 0;padding: 0;overflow: hidden; border: none;align-content: center"
            :id="`iframe${i}`" scrolling="no" :src="item" @load="onIframeLoad(i)"></iframe>
        </div>
      </div>
    </div>
    <!-- 穿透控制按钮 - 始终显示 -->
    <div class="restore-btn" :class="{ active: allowIframeClick }" @click.stop="toggleClickMode" @mousedown.stop>
      <i :class="allowIframeClick ? 'el-icon-unlock' : 'el-icon-lock'"></i>
      {{ allowIframeClick ? '已开启穿透' : '已关闭穿透' }}
    </div>
    <!-- 隐藏的 carousel 用于控制轮播逻辑 -->
    <el-carousel pause-on-hover="false" ref="nop" arrow="never" :interval="(ruleForm.interval*1000)"
      :autoplay="autoplay" :loop="autoplay" @change="handleCarouselChange" style="visibility: hidden; position: absolute;">
      <el-carousel-item v-for="(item, i) in ruleForm.urls" :key="item + i"></el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import router from "../../../router";

export default {
  name: 'box',
  props: {
    interval: {
      type: Number,
      default: function () {
        var box = localStorage.getItem("box");
        var boxUrl = [];
        if (box) {
          box = JSON.parse(box);
          return Number(box["interval"]);
        }
        return 30;
      },
    },
  },
  data: () => ({
    frameShowIndex: 0,
    dialogFormVisible: false,
    ruleForm: {
      interval: 500,
      urls: [],
    },
    autoplay: true,
    originalAutoplay: true,  // 保存原始的 autoplay 设置
    allowIframeClick: false,  // 控制iframe是否可点击
    activeIndex: 0,  // 当前显示的索引
    loading: true  // 加载状态
  }),
  mounted() {
    //去掉悬浮暂停
    //this.$refs.nop.handleMouseEnter = () => { };
    this.boxInit();
    var _this = this;
    // 使用捕获阶段监听键盘，提高优先级
    document.addEventListener('keyup', this.keyup, true);
    // 点击父页面时自动拉回焦点并关闭交互模式
    document.addEventListener('click', () => {
      _this.allowIframeClick = false;
      window.focus();
    });
    window.addEventListener('message', e => {
      if (e.data == 'next') {
        window.focus();
        // console.log('主页面焦点', document.hasFocus());
        _this.carousel(1);
      } else if (e.data == 'prev') {
        window.focus();
        _this.carousel(-1);
      }
    })
  },
  created() {

  },
  methods: {
    onIframeLoad(index) {
      // 第一个 iframe 加载完成时隐藏 loading
      if (index === 0) {
        this.loading = false;
      }
    },
    handleCarouselChange(index) {
      // carousel 切换时更新显示的索引
      this.activeIndex = index;
      this.frameShowIndex = index;
      // 切换时自动关闭交互模式，并拉回焦点
      this.allowIframeClick = false;
      this.$nextTick(() => {
        window.focus();
      });
    },
    carousel(e) {
      var fx = 0;
      if (e) {
        fx = e;
      } else {
        fx = 1;
      }

      // 开启穿透模式时，阻止按键切换，提示用户先关闭穿透
      if (this.allowIframeClick) {
        this.$message({
          message: '请先关闭穿透模式再切换页面',
          type: 'warning',
          duration: 1500
        });
        return;
      }

      if (fx == 1) {
        this.$refs.nop.next();
      } else if (fx == -1) {
        this.$refs.nop.prev();
      }

      console.log('---:', this.$refs.nop);

      // 更新 activeIndex，通过 v-show 切换显示，不会销毁 iframe
      this.activeIndex = (this.activeIndex + fx + this.ruleForm.urls.length) % this.ruleForm.urls.length;
      // 拉回焦点到父页面
      this.$nextTick(() => {
        window.focus();
      });

      this.frameShowIndex = this.frameShowIndex + fx;
      if (this.frameShowIndex >= this.ruleForm.urls.length) {
        this.frameShowIndex = 0;
      } else if (this.frameShowIndex < 0) {
        this.frameShowIndex = this.ruleForm.urls.length - 1;
      }

      var sliceStr = this.ruleForm.urls[this.frameShowIndex];
      console.log('---sliceStr:', sliceStr);
      var resultStr = sliceStr.slice(sliceStr.length - 9, sliceStr.length);

      console.log('---resultStr:', resultStr);
      if (sliceStr && sliceStr.indexOf('/box/item') > -1) {
        var id = "iframe" + this.frameShowIndex;
        document.getElementById(id).contentWindow.focus();
      } else if (sliceStr && sliceStr.indexOf('oee/weektracking_list') > -1) {
        var id = "iframe" + this.frameShowIndex;
        document.getElementById(id).contentWindow.focus();
      }
    },

    boxInit() {
      var box = localStorage.getItem("box");
      var boxUrl = [];
      if (box) {
        box = JSON.parse(box);
        this.ruleForm.interval = box["interval"];
        boxUrl = this.filterDayUrl(box["urls"]);
        this.ruleForm.urls = boxUrl;
        this.autoplay = box['boxType'] == 'M' ? false : true;
        // 保存原始 autoplay 设置
        this.originalAutoplay = this.autoplay;
      }

      if (this.ruleForm.urls.length == 0) {
        this.$message.error("未设置任何数据源");
      }

      var idx = 0;
    },
    insertArrayAt(arr1, index, arr2) {
      for (let i = 0; i < arr2.length; i++) {
        arr1.splice(index + i, 0, arr2[i]);
      }
      return arr1;
    },
    getUrlParams(url) {
      let urlStr = url.split('?')[1]
      let obj = {};
      let paramsArr = urlStr.split('&')
      for (let i = 0, len = paramsArr.length; i < len; i++) {
        let arr = paramsArr[i].split('=')
        obj[arr[0]] = arr[1];
      }
      return obj
    },
    filterDayUrl(boxUrl) {
      //自动追加路由，只限OEE 的产线看板，其他不影响。
      if (boxUrl && boxUrl.length > 0) {
        var copyUrl = [];
        for (var i = 0; i < boxUrl.length; i++) {
          var url = boxUrl[i];
          if (url && url.indexOf('oee/weektracking_kpi') > -1) {
            copyUrl.push(url);
          }
        }
        var keys = [];
        var domain = '';
        for (var u = 0; u < copyUrl.length; u++) {
          var url = copyUrl[u];
          domain = url.split('?')[0];
          var result = this.getUrlParams(url);
          if (result['key']) {
            keys.push(result['key']);
          }
        }
        var nows = new Date();
        let s1 = new Set(keys);
        var keys = Array.from(s1);
        var newUrl = [];
        console.log('now day', nows.getDay());
        if (nows.getDay() == 1) {
          //星期一
          for (var k = 0; k < keys.length; k++) {
            newUrl.push(domain + '?key=' + keys[k] + "&week=FRI");
            newUrl.push(domain + '?key=' + keys[k] + "&week=SAT");
            newUrl.push(domain + '?key=' + keys[k] + "&week=SUN");
          }
        } else {
          //其他日期
          for (var k = 0; k < keys.length; k++) {
            newUrl.push(domain + '?key=' + keys[k]);
          }
        }

        if (newUrl.length > 0) {
          var idx = boxUrl.findIndex(item => {
            return (item && item.indexOf('oee/weektracking_kpi') > -1);
          })
          var newArray = boxUrl.filter((url) => {
            if (url && url.indexOf('oee/weektracking_kpi') < 0) {
              return url;
            }
          });
          if (newArray.length < idx) {
            //直接加到最后
            boxUrl = newArray.concat(newUrl);
          } else {
            boxUrl = this.insertArrayAt(newArray, idx, newUrl);
          }
        }
        return boxUrl;
      }
    },
    back() {
      router.back();
    },
    toggleClickMode() {
      this.allowIframeClick = !this.allowIframeClick;
      // 开启穿透时强制关闭自动播放，关闭穿透时恢复原始设置
      if (this.allowIframeClick) {
        this.autoplay = false;
      } else {
        this.autoplay = this.originalAutoplay;
        // 关闭穿透时，强制移除所有 iframe 的焦点
        this.$nextTick(() => {
          for (let i = 0; i < this.ruleForm.urls.length; i++) {
            const iframe = document.getElementById(`iframe${i}`);
            if (iframe && iframe.contentWindow) {
              iframe.contentWindow.blur();
            }
          }
          window.focus();
        });
      }
      window.focus();
      this.$message({
        message: this.allowIframeClick ? '已开启穿透，可点击iframe内容' : '已关闭穿透，恢复键盘控制',
        type: this.allowIframeClick ? 'success' : 'info',
        duration: 1000
      });
    },
    keyup(e) {
      if (e.keyCode == 37 || e.keyCode == 38) {
        //上页 上箭头 左箭头
        console.log('上页:');
        this.carousel(-1);

      } else if (e.keyCode == 39 || e.keyCode == 40) {
        //下页 下箭头 右箭头
        console.log('下页:');
        this.carousel(1);
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.keyup, true);
  }
}
</script>
<style scoped src='./board.css'></style>
<style scoped>
.carousel-track {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease-in-out;
}
.carousel-item {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
}
.restore-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 99999;
  padding: 10px 20px;
  background: rgba(255, 64, 64, 0.3);
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s;
  user-select: none;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.restore-btn.active {
  background: rgba(103, 194, 58, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}
.restore-btn:hover {
  background: rgba(255, 64, 64, 0.9);
  border-color: #fff;
  transform: scale(1.05);
}
.restore-btn.active:hover {
  background: rgba(103, 194, 58, 0.9);
  border-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/box/board/board.vue